export default "__VITE_ASSET__BQDznj4o__"